import { useRouter } from 'next/router';
import { useEffect } from 'react';

import { postGetUserStatus } from '../api/auth';
import { useAppDispatch } from '../state';
import { HTTP_STATUS_CODE } from '../types';
import { message } from '../ui';
import { useLogout } from './useLogout';
import { useTalkieSignOut } from './useTalkieSignOut';
import { isTalkie } from '../utils/env';
export function useAuthCheck() {
  const dispatch = useAppDispatch();
  const router = useRouter();
  const { onSignOut } = useLogout();
  const { signOutWithFirebase } = useTalkieSignOut();
  useEffect(() => {
    if (router.pathname !== '/create/login')
      postGetUserStatus()
        .then((body) => {
          console.log(body);
          // 这里暂时没有用，因为 refreshAuthToken 不会 setCookie
          // const shouldRefreshToken = storage.auth.checkIfNeedRefreshToken();
          // if (shouldRefreshToken) {
          //   dispatch(refreshAuthToken());
          // }
        })
        .catch((err) => {
          if (
            err.status_code === HTTP_STATUS_CODE.NEED_REFRESH_TOKEN ||
            err.status_code === HTTP_STATUS_CODE.REFRESH_TOKEN_FAIL ||
            err.status_code === HTTP_STATUS_CODE.AUTH_TOKEN_MISSED
          ) {
            message.error('The auth token has expired, please log in again.');
            if (isTalkie) signOutWithFirebase();
            else onSignOut();
          }
        });
  }, [dispatch, onSignOut, router.pathname, signOutWithFirebase]);
}
